import { allStringsAreEmptyOrAllAreNonEmpty } from '../../utils/allStringsAreEmptyOrAllAreNonEmpty';

export function validateFieldSet(fields: (string | undefined)[]): boolean {
  return allStringsAreEmptyOrAllAreNonEmpty(fields);
}
